[
  {
    "key": "lang",
    "description": "title of the language",
    "fr": "Français",
    "en": "English",
    "es": "Español",
    "de": "Deutsch",
    "it": "Italiano",
    "oth1": "Other 1",
    "oth2": "Other 2"
  },
  {
    "key": "material",
    "description": "Title of materials",
    "fr": "Matière",
    "en": "Material",
    "es": "Material",
    "de": "Material",
    "it": "Materiale"
  },
  {
    "key": "color",
    "description": "Title of color",
    "fr": "Couleur",
    "en": "Color",
    "es": "Colores",
    "de": "Farben",
    "it": "Colori"
  },
  {
    "key": "customization",
    "description": "Title of customization",
    "fr": "Personnalisation",
    "en": "Customization",
    "es": "Personalización",
    "de": "Personalisierung",
    "it": "Personalizzazione"
  },
  {
    "key": "placeholder",
    "description": "Label for the textfield form",
    "fr": "Entrez votre texte",
    "en": "Enter your text",
    "es": "Introduzca su texto",
    "de": "Gib deinen Text ein",
    "it": "Inserisci il tuo testo"
  },
  {
    "key": "font",
    "description": "Label for the choice of the font",
    "fr": "Police",
    "en": "Font",
    "es": "Fuente",
    "de": "Schriftart",
    "it": "Carattere"
  },
  {
    "key": "backgrounds",
    "description": "Title of the backgrounds panel",
    "fr": "Arrière plan",
    "en": "Backgrounds",
    "es": "Fondos",
    "de": "Hintergrund",
    "it": "Sfondi"
  },
  {
    "key": "save",
    "description": "Save tool",
    "fr": "Sauvegarder",
    "en": "Save",
    "es": "Guardar",
    "de": "Sichern",
    "it": "Salva"
  },
  {
    "key": "confirm",
    "description": "Confirm button message",
    "fr": "Confirmer",
    "en": "Confirm",
    "es": "Confirmar",
    "de": "Konfirmand",
    "it": "Confermare"
  }
]